import { http } from "@/http";

class RobotService {
  async getRobotList(params) {
    return await http.get(`/monitoring/all-robot-sessions`,{ params });
  }
  async getRobotConnections(robotImei,params) {
    return await http.get(`/monitoring/robot-sessions/${robotImei}`,{ params });
  }
  async getSystemOperations(robotImei) {
    return await http.get(`/operations-logs/${robotImei}`);
  }
}
export default new RobotService();
